import React from 'react';
import { useIntl } from 'react-intl';
import { validationClasses } from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import ColumnValidationError from '@/components/errors/ColumnValidationError';
import UrlEditor from '@/components/text-editors/UrlEditor';
import { joinUrl, splitUrl } from '@/constants/urls';

const DatasourceUrlHostField = ({
  disabled,
  saveErrors,
  updateSettings,
  host,
}) => {
  const intl = useIntl();
  const hostError = saveErrors.find((e) => e.fields.includes(fields.HOST));
  const url = splitUrl(host);

  const updateUriLink = (link) => {
    const value = splitUrl(host);
    value.link = link;
    updateSettings({ host: joinUrl(value) });
  };

  const updateUriProtocol = (protocol) => {
    const value = splitUrl(host);
    value.protocol = protocol;
    updateSettings({ host: joinUrl(value) });
  };

  return (
    <ColumnValidationError
      error={hostError}
      htmlFor="datasource_host"
      labelId="save.dataset.datasource.host"
    >
      <UrlEditor
        id="datasource_host"
        className={validationClasses(hostError)}
        disabled={disabled}
        maxLength={globalFieldLengths.url}
        onChange={(e) => updateUriLink(e.target.value)}
        onProtocolChange={(e, { value }) => { updateUriProtocol(value); }}
        placeholder={intl.formatMessage({ id: 'save.dataset.datasource.host.placeholder' })}
        protocol={url.protocol}
        size="large"
        value={url.link || ''}
      />
    </ColumnValidationError>
  );
};

export default DatasourceUrlHostField;
